export type ForgotPasswordResult = {
  success: boolean;
  message?: string;
};

export type VerifyForgotPasswordResult = {
  token: string;
};

export async function sendForgotPasswordOtp(input: { email?: string; phone?: string }): Promise<ForgotPasswordResult> {
  const response = await fetch("/api/auth/user/forgot-password/send-otp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(input),
  });

  const json = await response.json();

  if (!response.ok || !json.success) {
    throw new Error(json.message || "Failed to send verification code");
  }

  return json;
}

export async function verifyForgotPasswordOtp(input: { email?: string; phone?: string; otp: string }): Promise<VerifyForgotPasswordResult> {
  const response = await fetch("/api/auth/user/forgot-password/verify-otp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(input),
  });

  const json = await response.json();

  if (!response.ok || !json.success) {
    throw new Error(json.message || "OTP verification failed");
  }

  return json.data; // contains token
}

export async function resetPassword(input: { email?: string; phone?: string; password?: string; token: string }): Promise<ForgotPasswordResult> {
  const response = await fetch("/api/auth/user/forgot-password/reset", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(input),
  });

  const json = await response.json();

  if (!response.ok || !json.success) {
    throw new Error(json.message || "Failed to reset password");
  }

  return json;
}
